/* The run sheet builder's pop-out window — one named window shared by the
   work order list ("Make run sheet", "Show run sheet") and the delivery
   runs page ("Edit"). The handle lives at module level so it survives the
   route change from Delivery runs to the list (same document). */

const BUILDER_WINDOW = "rf-run-builder";
const BUILDER_FEATURES = "left=100,top=250,width=1500,height=720";

let builder = null;

/* Opens (or brings back) the builder on `path`. A builder already showing
   that path is only focused — reloading it would throw away the route
   order and times typed into it. Returns the window, or null when the
   browser blocked the pop-up. Call it from a click, or it will be. */
export function openRunBuilder(path) {
  const win = window.open("", BUILDER_WINDOW, BUILDER_FEATURES);
  if (!win) return null;
  let showing = "";
  try {
    showing = win.location.pathname;
  } catch (e) {
    /* not readable yet — treat it as a fresh window */
  }
  if (showing !== path) win.location.href = path;
  win.focus();
  builder = win;
  return win;
}

export function closeRunBuilder() {
  if (builder && !builder.closed) builder.close();
  builder = null;
}

/* The builder closed itself after saving. */
export function forgetRunBuilder() {
  builder = null;
}
